<kendo-dialog title="Capture First Attend and Authorization Date" (close)="closeDialog()" [maxWidth]="1900"
    [width]="700" [minHeight]="300" (click)="$event.stopPropagation()">

    <div class="dialog-body">
        <div class="loading-container" *ngIf="loadSpinner">
            <kendo-loader *ngIf="loadSpinner" type="converging-spinner" size="large"></kendo-loader>
        </div>

        <div *ngIf="form">
            <form [formGroup]="form" class="k-form k-form-md">
                <div formArrayName="placementFirstAttendDateForm" *ngIf="isShowPlacementDetails === true">
                    <!-- Loop over each attendee -->
                    <div *ngFor="let attendDate of getPlacementFirstAttendDateControls(); let i = index"
                        [formGroupName]="i">
                        <div class="layout">
                            <ng-container *ngIf="!isSEITNotAlone()">
                                <div class="contact-details k-my-4">
                                    <div class="k-d-inline-flex k-mb-2  style">
                                        <h3 class="k-m-0" *ngIf="attendDate?.value?.summerFlag">Summer Special Education
                                            Itinerant Teacher Services (SEIT)</h3>
                                        <h3 class="k-m-0" *ngIf="!attendDate?.value?.summerFlag">10 Month Special
                                            Education Itinerant Teacher Services (SEIT)</h3>
                                    </div>
                                </div>
                            </ng-container>
                            <div class="contact-details k-my-4 k-d-flex k-gap-5">
                                <div class="k-d-flex k-flex-col k-mbr-2 k-w-full">
                                    <kendo-label text="Authorization Date" class="k-w-full" [for]="authDate">
                                    </kendo-label>
                                    <kendo-datepicker #authDate calendarType="classic"
                                        formControlName="authorizationDate" [format]="format" rounded="large"
                                        [readonly]="!canCaptureFirstAttend" class="k-w-full">
                                    </kendo-datepicker>
                                    <!-- </kendo-formfield> -->

                                    <!-- [min]="attendDa
                                     te?.value?.authorizationDate !== null ?? attendDate?.value?.authorizationDate"  -->
                                </div>
                                <div class="k-d-flex k-flex-col k-mbr-2 k-w-full">
                                    <kendo-label text="First Attend Date" class="k-w-full" [for]="firstDate">
                                    </kendo-label>
                                    <kendo-datepicker calendarType="classic" #firstDate
                                        formControlName="firstAttendDate" [format]="format" [max]="todayDate"
                                        [min]="attendDate?.value?.authorizationDate" class="k-w-full" rounded="large"
                                        [readonly]="!canCaptureFirstAttend">
                                    </kendo-datepicker>
                                    <kendo-formerror
                                        *ngIf="attendDate?.get('firstAttendDate')?.hasError('minError')">Error: The
                                        first attend date should be on or after the authorization date</kendo-formerror>
                                    <kendo-formerror
                                        *ngIf="attendDate?.get('firstAttendDate')?.hasError('maxError')">Error: The
                                        first attend date cannot be in the future</kendo-formerror>

                                    <!-- [min]="attendDa
                                     te?.value?.authorizationDate !== null ?? attendDate?.value?.authorizationDate"  -->
                                </div>
                            </div>

                            <ng-container *ngIf="isSEITNotAlone()">
                                <div class="contact-details k-my-4">
                                    <div class="k-d-inline-flex k-mb-2  style">
                                        <h3 class="k-m-0" data-qa="placement-heading"
                                            *ngIf="attendDate?.value?.summerFlag">Summer Placement</h3>
                                        <h3 class="k-m-0" data-qa="placement-heading"
                                            *ngIf="!attendDate?.value?.summerFlag">10 Month Placement</h3>
                                        <!-- <h3 class="k-m-0"> {{attendDate?.value?.mandateDescription}} <span class="redAlert" *ngIf="attendDate?.value?.isTwelveMonth"> 12 Month</span></h3> -->
                                    </div>
                                </div>
                                <div class="contact-details k-my-12">
                                    <div class="k-d-flex k-justify-content-stretch">
                                        <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                            <div class="edit-icon-container">
                                                <!-- <fa-icon icon="language" class="fa-m blue-icon-color"
                                                title="IEP Type"></fa-icon> -->
                                                <span class="margin">IEP Type : </span><span
                                                    data-qa="iep-type">{{attendDate?.value?.iepType}}</span>
                                            </div>
                                        </div>
                                        <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                            <div class="edit-icon-container">
                                                <!-- <fa-icon icon="clock" class="fa-m blue-icon-color"
                                                title="School DBN"></fa-icon> -->
                                                <span class="margin">School DBN : </span><span
                                                    data-qa="school-dbn">{{attendDate?.value?.schoolDBN}}</span>
                                            </div>
                                        </div>
                                        <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                            <div class="edit-icon-container">
                                                <fa-icon icon="school" class="fa-m blue-icon-color"
                                                    title="School Name"></fa-icon><span data-qa="school-name"
                                                    class="margin">{{attendDate?.value?.schoolName}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="contact-details k-my-12">
                                    <div class="k-d-flex k-justify-content-stretch">
                                        <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                            <div class="edit-icon-container">
                                                <!-- <fa-icon icon="user-group" class="fa-m blue-icon-color" title="Class"></fa-icon> -->
                                                <span class="margin">GroupType : </span><span
                                                    data-qa="group-type">{{attendDate?.value?.class}}</span>
                                            </div>
                                        </div>
                                        <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                            <div class="edit-icon-container">
                                                <span class="margin">District : </span><span
                                                    data-qa="district">{{attendDate?.value?.district}}</span>
                                            </div>
                                        </div>
                                        <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                                            <div class="edit-icon-container">
                                                <span class="margin">Grade : </span><span
                                                    data-qa="grade">{{attendDate?.value?.grade}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <span class="k-form-separator k-pb-6"
                                *ngIf="getPlacementFirstAttendDateControls()?.length - 1"></span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <kendo-dialog-actions  *ngIf="canCaptureFirstAttend">
        <div class=" k-mt-2 k-text-right margin  ">
            <div class="action-btns footer">
                <div class="action-btns__right">
                    <button kendoButton size="medium" rounded="large" fillMode="outline" themeColor="error"
                        (click)="closeDialog()">
                        Cancel
                    </button>
                    &nbsp;
                    <button kendoButton size="medium" (click)="submit()" rounded="large" fillMode="solid"
                        themeColor="primary" [disabled]="!form?.valid">
                        Submit
                    </button>
                </div>
            </div>
        </div>
    </kendo-dialog-actions>
</kendo-dialog>